import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center justify-center text-center font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 align-bottom",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-bg-secondary text-foreground shadow hover:bg-primary/80",
        solid: "bg-bg-tertiary/60",
        secondary:
          "border-transparent bg-accent text-accent-foreground hover:bg-accent/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "border text-foreground border-stroke-light bg-bg-tertiary/60",
      },
      size: {
        sm: "text-sm py-1 px-2",
        md: "px-2.5 py-1",
      },
      shape: {
        "rounded-xs": "rounded-xs",
        "rounded-md": "rounded-md",
        "rounded-lg": "rounded-lg",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "md",
      shape: "rounded-xs",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, shape, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, size, shape }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
